module.exports = __webpack_public_path__ + "img/lg_ring_y_i_1_null@2x.901b0655.png";